module.exports = __webpack_public_path__ + "static/img/payment-success.18f50200.png";